import type { WaitlistEntry } from '@growup/arena-shared';
import { Button, Card, Notice } from '@growup/ui';
import { useState } from 'react';

import { messageOf, send } from '../api';
import { formatTime } from '../format';
import { YouthPicker } from './YouthPicker';

/** Waiting list (RF-B2). While anyone is on it, the limits apply (RN-B3). */
export function WaitlistPanel({
  arenaId,
  waitlist,
  onChanged,
}: {
  arenaId: string;
  waitlist: WaitlistEntry[];
  onChanged: () => void;
}) {
  const [error, setError] = useState<string | null>(null);

  const run = async (method: string, path: string, body?: unknown) => {
    setError(null);
    try {
      await send(method, path, body);
      onChanged();
    } catch (e) {
      setError(messageOf(e));
    }
  };

  return (
    <Card headingLevel={2} title={`Lista de espera (${String(waitlist.length)})`}>
      <div className="flex flex-col gap-3">
        {waitlist.length === 0 ? (
          <p className="text-body text-gu-ink-muted">Ninguém à espera.</p>
        ) : null}
        <ol className="flex flex-col gap-2">
          {waitlist.map((entry, index) => (
            <li
              key={entry.id}
              className="flex items-center justify-between gap-2 border border-gu-line px-3 py-2"
            >
              <span>
                <span className="mr-2 text-gu-ink-muted">{index + 1}.</span>
                {entry.login}
                <span className="ml-2 text-caption text-gu-ink-muted">
                  {formatTime(entry.addedAt)}
                </span>
              </span>
              <Button
                variant="secondary"
                size="sm"
                onClick={() =>
                  void run(
                    'DELETE',
                    `/api/arena/arenas/${arenaId}/waitlist/${entry.id}?reason=left`,
                  )
                }
              >
                Tirar
              </Button>
            </li>
          ))}
        </ol>
        <YouthPicker
          arenaId={arenaId}
          label="Pôr na fila"
          onPick={(youth) =>
            void run('POST', `/api/arena/arenas/${arenaId}/waitlist`, {
              youthAccountId: youth.accountId,
            })
          }
        />
        {error ? <Notice tone="danger">{error}</Notice> : null}
        <p className="text-caption text-gu-ink-muted">Quem se senta num PC sai da fila sozinho.</p>
      </div>
    </Card>
  );
}
